<script>
  export let label = "You are offline";
  export let online = navigator.onLine;

  import { onDestroy } from "svelte";

  const setOnline = () => (online = true);
  const setOffline = () => (online = false);

  window.addEventListener("online", setOnline);
  window.addEventListener("offline", setOffline);

  onDestroy(() => {
    window.removeEventListener("online", setOnline);
    window.removeEventListener("offline", setOffline);
  });
</script>

{#if !online}
  <div class="absolute top-0 right-4 items-center">
    <p class="py-1 px-2 m-0 bg-red-300 border-1 border-t-0 border-red-600">
      {label}
    </p>
  </div>
{/if}
